// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const AccountTree = React.forwardRef(function AccountTree(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"/></SvgIcon>;
});
export default AccountTree;
